import config from 'config'

const OPEN_NAME = '-open'

/**
 * accordion :
 *   アコーディオン
 */

class Accordion {

  constructor(el) {
    this.el = el
    this.triggerEl = el.querySelector('.js-accordion-trigger')
    this.targetEl = el.querySelector('.js-accordion-target')

    if (!this.triggerEl || !this.targetEl) {
      return
    }

    this.attachEvent()
  }

  attachEvent() {
    this.triggerEl.addEventListener('click', (ev) => this.toggle(ev), false)
  }

  toggle(ev) {
    ev.preventDefault()
    const isOpen = this.triggerEl.classList.contains(OPEN_NAME)

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.triggerEl.classList.add(OPEN_NAME)
    this.targetEl.setAttribute('aria-expanded', true)
    this.targetEl.style.maxHeight = `${this.targetEl.scrollHeight}px`
  }

  close() {
    this.triggerEl.classList.remove(OPEN_NAME)
    this.targetEl.setAttribute('aria-expanded', false)
    this.targetEl.style.maxHeight = ''
  }
}

export default Accordion



// WEBPACK FOOTER //
// ./src/script/modules/Accordion.js